import Input from "./Input";

export default Input;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Input/index.js